<template>
    <div class="white-box white-box-no-tab">
        <TermsFrame
            :title="`${$route.meta.pageTitle}(${applyWay?.name})`"
            :subtitle="`為維護您的權益，線上申請金融機構轉帳前，請詳細閱讀線上申請「續期金融機構轉帳授權約定條款(${subtitle})」`"
            btn-text="本人已閱讀並同意"
            needLayer
            needGuideArrow
            :needBtn="isScrollToBottom"
            :content="content"
            :isLoading="isLoading"
            @isScrollToBottom="v => isScrollToBottom = v"
            @clickBtn="goNext"
        />
    </div>
</template>

<script>
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { getAgreeTermsACH, postAgreeACH } from '@/apis/aplCatlACH.js';
import TermsFrame from '@/components/template/TermsFrame.vue';
import routeName from '@/router/constant.js';
import codeList from '@/json/codeList.js';

export default {
    components: {
        TermsFrame,
    },
    setup() {
        const router = useRouter();
        const content = ref('');
        const store = useStore();
        const isScrollToBottom = ref(false);
        const isLoading = ref(false);
        // const subtitle = ref('台幣');
        const applyWay = computed(() => {
            return store.state.services.changeItemsResult[`${codeList.ACH}applyWay`];
        });
        const subtitle = computed(() => {
            return store.state.services.changeItemsResult[codeList.ACH]?.currency === 'NTD' ? '台幣' : '外幣';
        });
        const getTerms = () => {
            getAgreeTermsACH().then(res => {
                if (res.data.agreeTerms) content.value = res.data.agreeTerms.content;
            });
        };
        getTerms();
        const goNext = () => {
            router.push({ name: routeName.AUTH_ACCOUNT });
            isLoading.value = true;
            postAgreeACH().then(() => {
                router.push({ name: routeName.AUTH_ACCOUNT });
            }).finally(() => {
                isLoading.value = false;
            });
        };

        return { goNext, content, isLoading, subtitle, applyWay, isScrollToBottom };
    },
};
</script>
